import Colors from '@figma/panda/Colors'
import { Box, Stack, Typography } from '@mui/material'
import { FeatureItem } from './FeatureItem'

export const FeatureList = ({ localFeatures, handleRemoveFeature }) => {
  if (localFeatures.length === 0) {
    return (
      <Box
        width="100%"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: '32px',
        }}
      >
        <Typography color={Colors.base500}>No features added yet. Click "Add Feature" to get started.</Typography>
      </Box>
    )
  }

  return (
    <Stack width="100%" spacing="16px">
      {localFeatures.map((feature) => (
        <FeatureItem key={feature.id} feature={feature} onDelete={handleRemoveFeature} />
      ))}
    </Stack>
  )
}
